export { Body as SelectorButton } from './styles';
//# sourceMappingURL=index.js.map